export const DISPUTE_CATEGORY_OPTIONS = [
  { value: 'damage', translationKey: 'categories.damage' },
  { value: 'late_return', translationKey: 'categories.lateReturn' },
  { value: 'no_show', translationKey: 'categories.noShow' },
  { value: 'condition_mismatch', translationKey: 'categories.conditionMismatch' },
  { value: 'payment_issue', translationKey: 'categories.paymentIssue' },
  { value: 'communication_issue', translationKey: 'categories.communicationIssue' },
  { value: 'other', translationKey: 'categories.other' }
];

export const DISPUTE_CONTEXT_OPTIONS = [
  { value: 'general', translationKey: 'context.general' },
  { value: 'pickup', translationKey: 'context.pickup' },
  { value: 'return', translationKey: 'context.return' },
  { value: 'payment', translationKey: 'context.payment' },
  { value: 'deposit', translationKey: 'context.deposit' }
];

export const DISPUTE_ESCALATION_OPTIONS = [
  { value: 'user', translationKey: 'escalation.user' },
  { value: 'support', translationKey: 'escalation.support' },
  { value: 'admin', translationKey: 'escalation.admin' }
];

export const getDisputeCategoryLabel = (value) => {
  const option = DISPUTE_CATEGORY_OPTIONS.find((item) => item.value === value);
  return option ? option.translationKey : value;
};

export const getDisputeContextLabel = (value) => {
  const option = DISPUTE_CONTEXT_OPTIONS.find((item) => item.value === value);
  return option ? option.translationKey : value;
};

export const getDisputeEscalationLabel = (value) => {
  const option = DISPUTE_ESCALATION_OPTIONS.find((item) => item.value === value);
  return option ? option.translationKey : value;
};
